import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import About from "@/components/site/About";
import Booking from "@/components/site/Booking";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen text-neutral-100" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <About />
        <Booking />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
